var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUpload2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7688 6.795C21.3909 4.87993 20.3598 3.15547 18.8517 1.91615C17.3436 0.676837 15.452 -0.000441273 13.5 2.15704e-07C10.2487 2.15704e-07 7.425 1.845 6.01875 4.545C4.36526 4.72369 2.83613 5.50711 1.72517 6.74474C0.614217 7.98236 -0.000193165 9.58689 4.55544e-08 11.25C4.55544e-08 14.9737 3.02625 18 6.75 18H21.375C24.48 18 27 15.48 27 12.375C27 9.405 24.6938 6.9975 21.7688 6.795ZM15.75 10.125V14.625H11.25V10.125H7.875L13.1062 4.89375C13.3312 4.66875 13.68 4.66875 13.905 4.89375L19.125 10.125H15.75Z",
    fill: "#C6B382"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload2);
export default __webpack_public_path__ + "static/media/Icon_Upload2.b3d1066578f7398dd84cb2228356d339.svg";
export { ForwardRef as ReactComponent };